/**
 * Figures every BI dashboard computes the same way (CU-869fmjzrh S2; first in "Season vs last year", CU-869fmhmx8):
 * the median of the market and your place in it. Pure and alias-free: `node --test` runs it.
 */

const present = v => v !== null && v !== undefined && !Number.isNaN(v)

/** A price that can be ranked: a finite number (no null, NaN or text) */
export const isPrice = v => typeof v === 'number' && Number.isFinite(v)

export function median(values) {
	const xs = values.filter(present).sort((a, b) => a - b)
	if (!xs.length) return null
	const m = xs.length >> 1
	return xs.length % 2 ? xs[m] : (xs[m - 1] + xs[m]) / 2
}

/**
 * Your place among `values` (the prices you are ranked with; yours may be among them or not): 1 = the cheapest, ties
 * share the place. `null` when you have no price; prices that are not numbers (null, NaN, text) never count.
 */
export function rankOf(values, youValue) {
	if (!isPrice(youValue) || !Array.isArray(values)) return null
	return 1 + values.filter(v => isPrice(v) && v < youValue).length
}
